import type { PhysicalCardFaceSpec } from "./CardFaceTextureCache";
import { hiddenPhysicalCardFaceSpec } from "./CardFaceTextureCache";
import { PhysicalCard3D } from "./PhysicalCard3D";

export function CardStack3D({
  count,
  position,
  rotationZ = 0,
  topFace,
  reducedMotion,
}: {
  readonly count: number;
  readonly position: readonly [number, number, number];
  readonly rotationZ?: number | undefined;
  readonly topFace?: PhysicalCardFaceSpec | undefined;
  readonly reducedMotion: boolean;
}) {
  const visibleLayers = Math.min(5, Math.max(1, count));
  const hiddenFace = hiddenPhysicalCardFaceSpec();
  return (
    <group>
      {Array.from({ length: visibleLayers }, (_, index) => {
        const isTop = index === visibleLayers - 1;
        return (
          <PhysicalCard3D
            face={isTop && topFace !== undefined ? topFace : hiddenFace}
            position={[
              position[0] + index * 0.012,
              position[1] + index * 0.028,
              position[2] - index * 0.008,
            ]}
            rotation={[-Math.PI / 2, 0, rotationZ + index * 0.008]}
            scale={0.58}
            reducedMotion={reducedMotion}
            key={index}
          />
        );
      })}
    </group>
  );
}
